<template>
  <v-app class="home-page" :key="updateLanguage" >
    <header-comp :activeButton="0" :userInfo="dealersData" v-on:update="onStep1Update" />
    <div class="map-container">
      <v-row>
        <v-col cols="12" v-if="boxData">
          <l-map :zoom="zoom" :center="center" style="height: 100%; width: 100%">
            <l-tile-layer :url="url" :attribution="attribution" />
            <!-- <l-marker :lat-lng="markerLoc" :icon="icon" /> -->

            <!-- <l-marker :lat-lng="[47.413220, -1.209482]" :icon="icon"></l-marker> -->
            <!-- <l-marker :lat-lng="[47.413220, -1.199482]">
              <l-icon
                :icon-size="dynamicSize"
                :icon-anchor="dynamicAnchor"
                icon-url="static/images/baseball-marker.png"
              ></l-icon>
            </l-marker>-->
            <l-marker
              v-for="item in boxData.systems"
              :key="item.system.id"
              :lat-lng="[item.system.geolat ? item.system.geolat : 0, item.system.geolng ? item.system.geolng : 0]"
              v-on:click="markerClicked(item.system)"
            >
              <l-tooltip :content="renderMarkersTooltip(item.system)" />
              <l-icon :icon-anchor="staticAnchor" class-name="someExtraClass">
                <img :src="chooseMapPin(item.system.sysstate)" width="30px" />
              </l-icon>
            </l-marker>
          </l-map>
          <!-- <div class="floating-button-container">
            <div>
            <v-btn 
              class="mx-2" dark color="primary" 
              @mouseover="clearAlarmToggle = true"
              @mouseleave="clearAlarmToggle = false"
              @click="clearAlarmCount < 3 ? buttonPush('clearalarm') : null"
            >
              <span v-if="clearAlarmToggle">{{ "lng_clear_alram_btn" | translate }}</span>
              <v-icon right dark>mdi-bell-off</v-icon>
            </v-btn>
            </div>
            <div>
              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn 
                    class="mx-2" dark color="primary"
                    @mouseover="testAlarmToggle = true"
                    @mouseleave="testAlarmToggle = false"
                    v-bind="attrs"
                    v-on="on"
                  >
                  <span v-if="testAlarmToggle">{{ "lng_test_alram_btn" | translate }}</span>
                    <v-icon right dark>mdi-alarm</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item
                    v-for="(item, index) in testAlarmOptions"
                    :key="index"
                  >
                    <v-list-item-title style="cursor: pointer;" @click="testAlarmCount < 3 ? buttonPush('testalarm') : null">
                      {{ item.title | translate }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
          </div> -->
          <v-alert
            v-if="showAlert"
            class="alert-on-map"
            dense
            :type="alertData.type"
          >
            {{ alertData.msg }}
          </v-alert>
        </v-col>
      </v-row>
    </div>
    <MarkerModal
      :user-token="userToken"
      :dialog-title="'lng_box_detail_key_txt' | translate"
      :box-data="boxItem"
      :openDialog="openMarkerModal"
      :closeDialog="closeMarkerModalFunc"
      @buttonPush="buttonPush"
    ></MarkerModal>
    <AddBoxModal
      :complete-address="addressObj"
      :user-token="userToken"
      :dialog-title="'lng_add_box_txt' | translate"
      :openDialog="openBoxModal"
      :closeDialog="closeBoxModalFunct"
      :logout-active="true"
      @successAddingBox="closeBoxModalFunct"
    ></AddBoxModal>
  </v-app>
</template>

<script>
// @ is an alias to /src
import Menu from "../../components/Menu.vue";
import { LMap, LTileLayer, LMarker, LIcon, LTooltip } from "vue2-leaflet";
import L from "leaflet";
import GlobalService from "../../services/global-service";
import HeaderComp from "../../components/HeaderComp";
import router from "../../router";
import { translateFunc } from "../../common/Filters.js"
import MarkerModal from "../../components/MarkerModal"
import AddBoxModal from "../../components/AddBoxModal";
import onStep1Update from "../../mixins/ChangeLanguage"


export default {
  name: "Home",
  components: {
    Menu,
    LMap,
    LTileLayer,
    LMarker,
    LIcon,
    LTooltip,
    HeaderComp,
    MarkerModal,
    AddBoxModal
  },
  data() {
    return {
      dealersData: undefined,
      timerInstance: undefined,
      userToken: undefined,
      zoom: 8,
      center: L.latLng(56.426264, 9.957401),
      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      markerLoc: L.latLng(56.426264, 9.957401),
      icon: L.icon({
        iconUrl: "../icons/user-icon.png",
        iconSize: [32, 37],
        iconAnchor: [16, 37]
      }),
      staticAnchor: [16, 37],
      // customText: "Foobar",
      // iconSize: 64
      boxData: undefined,
      userData: undefined,
      clearAlarmToggle: false,
      testAlarmToggle: false,
      showAlert: false,
      alertData: {
        type: "success",
        msg: ""
      },
      openMarkerModal: false,
      boxItem: {},
      clearAlarmCount: 0,
      testAlarmCount: 0,
      testAlarmOptions: [
        { title: 'test_alarm_option1' },
        { title: 'test_alarm_option2' },
        { title: 'test_alarm_option3' }
      ],
      addressObj: {},
      openBoxModal: false
    };
  },
  async mounted() {
    let token = sessionStorage.getItem("userToken");
    this.userToken = token;
    await this.fetchUserInfo(token);
    this.fetchMapsData(token);
    this.dealersData = this.userData.dealer;
  },
  mixins:[onStep1Update],
  methods: {
    async fetchMapsData(token) {
      this.boxData = await GlobalService.getBoxesForMap(token);

      this.boxData.systems.sort((a, b) => {
        if (a.sysstate !== "1") {return -1;}
        return 0;
      });

      if (this.boxData.systems.length) {
        this.center = L.latLng(this.boxData.systems[0].system.geolat, this.boxData.systems[0].system.geolng);
        sessionStorage.setItem("systemsData", JSON.stringify(this.boxData.systems));
      } else {
        this.addressObj = {
          addr1: this.userData.dealer.address1,
          addr2: this.userData.dealer.address2,
          city: this.userData.dealer.city,
          zip: this.userData.dealer.zip,
          country: this.userData.dealer.country,
          lat: this.userData.dealer.geolat,
          lng: this.userData.dealer.geolng
        };
        this.openBoxModal = true;
      }
    },
    async fetchUserInfo(token) {
      this.userData = await GlobalService.getUserInfo(token);
      if (this.userData.dealer) {
       sessionStorage.setItem("userData", JSON.stringify(this.userData.dealer));
      }
    },
    markerClicked(box) {
      this.boxItem = box;
      this.openMarkerModal = true;
      /* router.push("/event-logs"); */
    },
    chooseMapPin(status) {
      if (status === "0") {
        return require("../../assets/icons/green-pin.png");
      } else if (status === "1") {
        return require("../../assets/icons/red-pin.png");
      } else {
        return require("../../assets/icons/grey-pin.png");
      }
    },
    async buttonPush(type, box){
      if(this.userToken && box.id){
        let response = await GlobalService.alarmButton(this.userToken, box.id , type);
        if (response.status === 0) {
          this.alertData.type = "success"
          this.alertData.msg = type === "testalarm" ? translateFunc("lng_test_alarm_success_txt") : translateFunc("lng_clear_alarm_success_txt")
        } else {
          this.alertData.type = "error"
          this.alertData.msg = translateFunc(response.msg);
        }
        this.fetchMapsData(this.userToken);
        this.showAlert = true;
        this.timerInstance = setTimeout(() => {
          this.showAlert = false;
        }, 5000);
        if(type === "clearalarm") this.clearAlarmCount++;
        else if(type === "testalarm") this.testAlarmCount++;
      }
    },
    renderMarkersTooltip(item){
      if (item.sysstate === "0") {
        return translateFunc('lng_marker_green');
      } else if (item.sysstate === "1") {
        return translateFunc('lng_marker_red');
      } else {
        return translateFunc('lng_marker_grey');
      }
    },
    closeMarkerModalFunc(){
      this.openMarkerModal = false;
    },
    closeBoxModalFunct() {
      this.openBoxModal = false;
      this.fetchMapsData(this.userToken);
    },
  },
  beforeDestroy() {
    clearTimeout(this.timerInstance);
  }
};
</script>
<style>
.home-page {
  height: 100%;
}
.d-menu-bar {
  display: flex;
  align-items: center;
  justify-content: center;
}
.floating-button-container {
  position: absolute;
  top: 3rem;
  right: 3rem;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: flex-end;
}
.floating-button-container .v-btn {
  margin-bottom: 0.5rem;
}
.alert-on-map {
  position: absolute !important;
  right: 20px;
  z-index: 9999;
  bottom: 0;
}
.map-container {
  height: calc(100vh - 80px);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
@media only screen and (max-width: 768px){
  .map-container {
    height: calc(100vh - 65px);
  } 
}
</style>